import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import {
  getActiveBlogsResponse,
  getAllBlogCategoryResponse,
  getAllBlogsResponse,
  getBlogsByIdResponse,
  getInActiveBlogsRespose,
} from "../actions";

export function* createBlogsEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosPost(`blogs`, action.data?.payload));
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Blogs saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* updateBlogsEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPut(`blogs/${action.data?.payload?.id}`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Blogs updated successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getAllBlogsEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`blogs/all`));
    yield put(getAllBlogsResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllBlogsResponse([]));
  }
}

// export function* getAllBlogCategoryEffectSaga(action) {
//   try {
//     const { data } = yield call(() => axiosGet(`blog-category/all`));
//     yield put(getAllBlogCategoryResponse(data));
//     action?.payload?.callback?.success?.(data);
//   } catch (e) {
//     console.log(e);
//     yield put(getAllBlogCategoryResponse([]));
//   }
// }

export function* getActiveBlogsEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`blogs/active`));
    yield put(getActiveBlogsResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getActiveBlogsResponse([]));
  }
}

export function* getInActiveBlogsEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`blogs/in-active`));
    yield put(getInActiveBlogsRespose(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getInActiveBlogsRespose([]));
  }
}

export function* getBlogsByIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`blogs/${action?.payload?.id}`));
    yield put(getBlogsByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getBlogsByIdResponse([]));
  }
}

export function* deleteBlogsEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosDelete(`blogs/${action.payload?.id}`)
    );
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "Blogs deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* blogsWatcherSaga() {
  yield takeLatest(types.CREATE_BLOGS, createBlogsEffectSaga);
  yield takeLatest(types.UPDATE_BLOGS, updateBlogsEffectSaga);
  yield takeLatest(types.GET_ALL_BLOGS, getAllBlogsEffectSaga);
  yield takeLatest(types.GET_BLOGS, getBlogsByIdEffectSaga);
  yield takeLatest(types.DELETE_BLOGS, deleteBlogsEffectSaga);
  yield takeLatest(types.GET_ACTIVE_BLOG, getActiveBlogsEffectSaga);
  yield takeLatest(types.GET_INACTIVE_BLOG, getInActiveBlogsEffectSaga);
  // yield takeLatest(types.GET_ALL_BLOG_CATEGORY, getAllBlogCategoryEffectSaga);
}
